import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';
import { TextMsgFiltersResponse } from '../../models/contact-modal/textMsgFilters.model';
import { TxtMsg, TxtMsgResponse } from '../../models/contact-modal/txtMsg.model';

@Injectable({
  providedIn: 'root'
})
export class OutBoundTextMsgService {

  private baseUrl: string;
    private api: string = "api/Engage/OutBoundTextMsg";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  async getTextMsgFilters(encryptedUser: string, clpCompanyId: number, cLPUserID: number, contactId: number): Promise<TextMsgFiltersResponse | void> {
    const a = await this.httpClient
      .get<TextMsgFiltersResponse>(`${this.baseUrl}/Get_TextMsg_Filters/${clpCompanyId}/${cLPUserID}/${contactId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "cLPUserID - " + cLPUserID + "," + "contactId - " + contactId, encryptedUser, "OutBoundTextMsgService", "getTextMsgFilters"); });
    return a;
  }

  async sendMessage(encryptedUser: string, txtMsg: TxtMsg): Promise<TxtMsgResponse | void> {    
    const a = await this.httpClient.post<TxtMsgResponse>(`${this.baseUrl}/SendMessage`, txtMsg, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, txtMsg, "r - " + encryptedUser, encryptedUser, "OutBoundTextMsgService", "sendMessage"); });
    return a;
  }
}
